// The resume offer: one outlined pill holding the "Resume watching at" action and a small dismiss
// X, like a ChipInput chip's remove button. Two sibling buttons rather than an X nested inside the
// action, which would be a button inside a button.
import { Icon } from "@grackle/ui";
import { clock } from "./transcript";

export default function ResumeChip({
  at,
  onResume,
  onDismiss,
}: {
  /** Seconds */
  at: number;
  onResume: () => void;
  /** Hide the offer and forget the saved position. */
  onDismiss: () => void;
}) {
  return (
    <span className="resume-chip">
      <button
        type="button"
        className="gk-btn gk-btn--ghost gk-btn--sm resume-chip__resume"
        onClick={onResume}
      >
        <Icon name="clock-counter-clockwise" size={18} />
        {/* One flex item, so the button's icon gap doesn't widen the space before the time. */}
        <span>
          Resume watching at <span className="mono">{clock(at)}</span>
        </span>
      </button>
      <button type="button" className="resume-chip__dismiss" aria-label="Dismiss" title="Dismiss" onClick={onDismiss}>
        <Icon name="x" size={12} />
      </button>
    </span>
  );
}
